export type ApiFieldErrors = Record<string, string[]>

export class ApiError extends Error {
  readonly status: number
  readonly errors: ApiFieldErrors

  constructor(
    message: string,
    options: {
      status: number
      errors?: ApiFieldErrors
    }
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = options.status
    this.errors = options.errors ?? {}
  }
}
